export const searchCodebase = (toolMessage: any, results: any) => {
    const textContent = "Here are the files returned from your search:\n"

    const content = [{
        type: 'text',
        text: `${textContent}${results.toolString}`
    }];
    const truncatedContent = [{
        type: 'text',
        text: `${textContent}:\n\`\`\`\n<Truncated for brevity>\n\`\`\``
    }];

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
